import column from '../../../../common/list-table/helpers/columns';

export default (data) => {
  const { FilteredTextColumn } = column(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Country', 'country'),
        new FilteredTextColumn('IMPC', 'impc'),
      ],
    },
  ];
};
